// available rules for each user role
import axios from "axios";
import { nuclearn_api_url } from "src/App";
import { useQuery } from "react-query";

export const getAuthConfig = (nuclearn_api_url) => {
  return axios.get(nuclearn_api_url + `/auth/config`).then((res) => {
    return res.data;
  });
};

export const useAuthConfig = () => {
  return useQuery("config", () => getAuthConfig(nuclearn_api_url), {
    refetchOnWindowFocus: false,
  });
};

export const getOPConfig = () => {
  return axios.get(nuclearn_api_url + `/auth/op-config`).then((res) => {
    return res.data;
  });
};

export const useGetOPConfig = () => {
  return useQuery("opConfig", () => getOPConfig(nuclearn_api_url), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 20,
    cacheTime: 1000 * 60 * 60,
  });
};

export default useAuthConfig;
